class FuhCartToast extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('[data-fuh-toast-image]');
    this.fallback = this.querySelector('[data-fuh-toast-fallback]');
    this.titleElement = this.querySelector('[data-fuh-toast-title]');
    this.seconds = this.querySelector('[data-fuh-toast-seconds]');
    this.progress = this.querySelector('[data-fuh-toast-progress]');
    this.status = document.querySelector('[data-fuh-toast-status]');
    this.onAdded = event => this.show(event.detail);
    this.onKey = event => { if (event.key === 'Escape') this.dismiss(); };
    this.onClick = event => {
      if (event.target.closest('[data-fuh-toast-close], [data-fuh-cart]')) this.dismiss();
    };
    this.onImageError = () => { this.image.hidden = true; this.fallback.hidden = false; };
    document.addEventListener('fuh:cart-added', this.onAdded);
    document.addEventListener('keydown', this.onKey);
    this.addEventListener('click', this.onClick);
    this.image.addEventListener('error', this.onImageError);
  }

  show({ item, refreshed }) {
    this.stopTimer();
    const product = item?.items?.[0] || item || {};
    const name = product.product_title || product.title || 'المنتج';
    this.titleElement.textContent = name;
    this.titleElement.title = name;
    const imageSource = product.featured_image?.url || product.image;
    this.image.hidden = true;
    this.fallback.hidden = false;
    this.image.removeAttribute('src');
    if (typeof imageSource === 'string' && imageSource) {
      try {
        const url = new URL(imageSource, window.location.origin);
        if (url.protocol === 'https:' || url.protocol === 'http:') {
          url.searchParams.set('width', '104');
          this.image.src = url.href;
          this.image.hidden = false;
          this.fallback.hidden = true;
        }
      } catch { /* Keep the bag icon if a product has no usable image. */ }
    }
    this.hidden = false;
    if (this.status) this.status.textContent = refreshed
      ? 'تمت إضافة ' + name + ' إلى السلة'
      : 'تمت إضافة ' + name + '. اعرض السلة لمراجعة طلبك.';
    this.deadline = performance.now() + 5000;
    this.updateTimer();
    this.ticker = setInterval(() => this.updateTimer(), 100);
    this.timeout = setTimeout(() => this.dismiss(), 5000);
  }

  updateTimer() {
    const remaining = Math.max(0, this.deadline - performance.now());
    this.seconds.textContent = String(Math.ceil(remaining / 1000));
    this.progress.style.strokeDashoffset = String(1 - remaining / 5000);
  }

  stopTimer() {
    clearInterval(this.ticker);
    clearTimeout(this.timeout);
  }

  dismiss() {
    this.stopTimer();
    if (this.contains(document.activeElement)) document.getElementById('cart-icon-bubble')?.focus();
    this.hidden = true;
  }

  disconnectedCallback() {
    this.stopTimer();
    document.removeEventListener('fuh:cart-added', this.onAdded);
    document.removeEventListener('keydown', this.onKey);
    this.removeEventListener('click', this.onClick);
    this.image?.removeEventListener('error', this.onImageError);
  }
}

if (!customElements.get('fuh-cart-toast')) customElements.define('fuh-cart-toast', FuhCartToast);
